import $ from 'jquery';
import gsap from 'gsap';

function hero() {
	const $container = $('.c-hero_container--animation'),
				$direction = $container.attr('data-animation-dir');

	if( !$container.length ) return;

	const directions = {
		right: {
			x: 1000,
			opacity: 0,
			duration: .5,
		},
		left: {
			x: -1000,
			opacity: 0,
			duration: .5,
		},
		top: {
			y: -1000,
			opacity: 0,
			duration: .5,
		},
		bottom: {
			y: 1000,
			opacity: 0,
			duration: .5,
		},
	};

	let tl = gsap.timeline();
	tl.from($container, directions[$direction]);
}

export { hero };